import React from 'react';

const NoConnections = () => <p className="no-pending-connections">You have no connections.</p>;

export default NoConnections;
